@use "../../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../../styles/layout";

.popoverContent {
    background: var(--color-white);
    border-top: 2px solid var(--color-crimson);
    border-right: 1px solid var(--color-kingly-cloud);
    border-bottom: 1px solid var(--color-kingly-cloud);
    border-left: 1px solid var(--color-kingly-cloud);
    margin: 0 auto;
    position: relative;
    width: 85vw;
    z-index: 10;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        width: 100vw;
    }
}

.close {
    align-items: center;
    border-top: 1px solid var(--color-kingly-cloud);
    color: var(--color-crimson);
    display: flex;
    gap: 4px;
    justify-content: center;
    padding: 0.5rem 0;
    text-align: center;
    width: 100%;

    & svg {
        fill: var(--color-crimson);
        height: 14px;
        width: 16px;
    }
}
